import React from 'react';
import { useNavigate } from 'react-router-dom';


const Header = () => {
  const navigate = useNavigate();

  const goToHome = () => navigate('/');
  const goToContact = () => navigate('/contact');
  const goToLogin = () => navigate('/Login');
  const goToAboutUs = () => navigate('/AboutUs');

  return (
    <>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow">
        <div className="container-fluid">
          {/* Brand */}
          <a className="navbar-brand" href="/">KLV Diagnostic</a>

          {/* Hamburger button for mobile */}
          <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu">
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Desktop Links */}
          <div className="collapse navbar-collapse d-none d-lg-flex justify-content-end">
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <button className="btn nav-link text-white" onClick={goToHome}>Home</button>
              </li>
              <li className="nav-item">
                <button className="btn nav-link text-white" onClick={goToContact}>Contact</button>
              </li>
              <li className="nav-item">
                <button className="btn nav-link text-white" onClick={goToAboutUs}>About Us</button>
              </li>
              <li className="nav-item">
                <button className="btn nav-link text-white" onClick={goToLogin}>Login</button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Mobile Offcanvas Menu */}
      <div
        className="offcanvas offcanvas-start bg-dark text-white"
        tabIndex="-1"
        id="mobileMenu"
        aria-labelledby="mobileMenuLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="mobileMenuLabel">Menu</h5>
          <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas"></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav">
            <li className="nav-item mb-2">
              <button className="btn nav-link text-white" onClick={goToHome} data-bs-dismiss="offcanvas">Home</button>
            </li>
            <li className="nav-item mb-2">
              <button className="btn nav-link text-white" onClick={goToContact} data-bs-dismiss="offcanvas">Contact</button>
            </li>
            <li className="nav-item mb-2">
              <button className="btn nav-link text-white" onClick={goToAboutUs} data-bs-dismiss="offcanvas">About Us</button>
            </li>
            <li className="nav-item mb-2">
              <button className="btn nav-link text-white" onClick={goToLogin} data-bs-dismiss="offcanvas">Login</button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Header;
